/* AAA Treats - interactive concept layer (theme-wide).
   Runs on every template. Degrades to a plain, fully readable site
   if GSAP fails to load or the visitor prefers reduced motion.

   NOTE: when the homepage is built from the aaa-* concept sections, those
   sections carry [data-aaa-custom] and bring their own design and motion.
   This file then skips its automatic material/chapter/marquee injection so
   the two do not fight each other.

   RULE ADDED 2026-09-10 after the product page shipped with an invisible buy
   column: nothing a customer must read or click is ever hidden by this file.
   Reveals are for decorative headings and media only. Anything that hides an
   element must hide it only at the moment its trigger fires (immediateRender
   false), never at page load. snippets/aaa-visible.liquid is the backstop. */
(function () {
  'use strict';

  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = matchMedia('(hover:hover) and (pointer:fine)').matches;

  function boot() {
    var G = window.gsap;
    if (!G || reduce) { document.documentElement.classList.add('aaa-noanim'); }
    if (G && window.ScrollTrigger) G.registerPlugin(window.ScrollTrigger);

    var main = document.querySelector('main[data-template]');
    var template = main ? main.dataset.template : '';
    var hasCustom = !!document.querySelector('[data-aaa-custom]');

    /* sticky header state */
    var hw = document.querySelector('.header-wrapper');
    if (hw) {
      var onScroll = function () { hw.classList.toggle('aaa-stuck', window.scrollY > 12); };
      addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    function labelFor(sec) {
      var h = sec.querySelector('h2, .title, .h1, .h2');
      if (!h) return '';
      var t = (h.textContent || '').trim().toLowerCase();
      if (t.indexOf('deliver') > -1 || t.indexOf('date') > -1) return 'The route';
      if (t.indexOf('how') > -1 || t.indexOf('work') > -1) return 'How it works';
      if (t.indexOf('best') > -1 || t.indexOf('shop') > -1 || t.indexOf('favour') > -1) return 'The table';
      if (t.indexOf('about') > -1 || t.indexOf('story') > -1 || t.indexOf('who') > -1) return 'The craft';
      return '';
    }

    function injectMarquee() {
      var names = Array.prototype.slice.call(document.querySelectorAll('.card__heading a'))
        .map(function (a) { return (a.textContent || '').trim(); })
        .filter(Boolean);
      if (names.length < 4) return;
      names = names.slice(0, 14);

      var bar = document.createElement('div');
      bar.className = 'aaa-marquee';
      bar.setAttribute('aria-hidden', 'true');
      var track = document.createElement('div');
      track.className = 'aaa-mq';
      var html = names.map(function (n) { return '<span>' + n + '</span>'; }).join('');
      track.innerHTML = html + html;
      bar.appendChild(track);

      var hdr = document.querySelector('.header-wrapper');
      if (hdr && hdr.parentNode) hdr.parentNode.insertBefore(bar, hdr.nextSibling);

      if (!G || reduce) return;
      requestAnimationFrame(function () {
        var half = track.scrollWidth / 2;
        if (half > 0) G.to(track, { x: -half, duration: 46, ease: 'none', repeat: -1 });
      });
    }

    /* only dress a stock Dawn homepage; the concept sections dress themselves */
    if (template === 'index' && !hasCustom) {
      var secs = Array.prototype.slice.call(
        document.querySelectorAll('main .shopify-section')
      ).filter(function (s) { return s.offsetHeight > 120; });

      secs.forEach(function (sec, i) {
        if (i > 0 && i % 3 === 2) sec.classList.add('aaa-dark');
        else if (i > 0 && i % 5 === 4) sec.classList.add('aaa-clay-block');

        var label = labelFor(sec);
        if (label && i > 0) {
          var ch = document.createElement('div');
          ch.className = 'aaa-chapter';
          ch.innerHTML = '<b>' + label + '</b>';
          sec.insertBefore(ch, sec.firstChild);
        }
      });

      injectMarquee();
    }

    /* 3D tilt on stock Dawn product cards (collection pages, recommendations) */
    if (fine && !reduce) {
      document.querySelectorAll('.card-wrapper').forEach(function (w) {
        var inner = w.querySelector('.card__inner');
        if (!inner) return;
        w.addEventListener('mousemove', function (e) {
          var r = w.getBoundingClientRect();
          var px = (e.clientX - r.left) / r.width - 0.5;
          var py = (e.clientY - r.top) / r.height - 0.5;
          inner.style.transform =
            'rotateY(' + (px * 8).toFixed(2) + 'deg) rotateX(' + (-py * 8).toFixed(2) +
            'deg) translateY(-6px) scale(1.012)';
        });
        w.addEventListener('mouseleave', function () {
          inner.style.transition = 'transform .6s cubic-bezier(.2,.8,.3,1), box-shadow .45s ease';
          inner.style.transform = '';
          setTimeout(function () { inner.style.transition = 'box-shadow .45s ease'; }, 600);
        });
        w.addEventListener('mouseenter', function () {
          inner.style.transition = 'box-shadow .45s ease';
        });
      });
    }

    if (!G || reduce) return;

    /* Scroll reveals. DECORATIVE ELEMENTS ONLY.
       .product__info-container and .cart__items were removed from this list on
       2026-09-10: they carry the price, quantity, Add to cart and description,
       and a stalled tween left the entire buy column at opacity 0 on live. */
    document.querySelectorAll(
      'main .shopify-section > * > .title-wrapper, main .rich-text__blocks, ' +
      'main .banner__content, main .collection-hero__text-wrapper, main .contact'
    ).forEach(function (el) {
      el.classList.add('aaa-reveal');
      G.to(el, {
        opacity: 1, y: 0, duration: .85, ease: 'power3.out',
        scrollTrigger: { trigger: el, start: 'top 88%', once: true }
      });
    });

    /* fromTo with immediateRender:false, so grid items are never hidden before
       their trigger actually fires. A from() here would blank the grid for good
       if ScrollTrigger measured stale positions. */
    document.querySelectorAll('.product-grid, .grid--quarter, .collection .grid').forEach(function (grid) {
      var items = grid.querySelectorAll('.grid__item');
      if (!items.length) return;
      G.fromTo(items,
        { opacity: 0, y: 26 },
        {
          opacity: 1, y: 0, duration: .65, stagger: .05, ease: 'power3.out',
          immediateRender: false,
          scrollTrigger: { trigger: grid, start: 'top 92%', once: true }
        });
    });

    document.querySelectorAll('.banner__media img, .collection-hero img').forEach(function (img) {
      G.to(img, {
        yPercent: 7, ease: 'none',
        scrollTrigger: { trigger: img, start: 'top bottom', end: 'bottom top', scrub: .6 }
      });
    });

    /* product media may fade, the info column may not */
    var pm = document.querySelector('.product__media-wrapper');
    if (pm) G.from(pm, { opacity: 0, y: 30, duration: .9, ease: 'power3.out' });

    /* Product images settle after ScrollTrigger has measured the page, which
       leaves triggers pointing at the wrong offsets and reveals that never
       fire. Re-measure once everything has loaded, then sweep up anything
       still hidden inside the viewport. */
    function sweep() {
      document.querySelectorAll('.aaa-reveal, .grid__item').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) return;
        if (parseFloat(getComputedStyle(el).opacity) > 0.99) return;
        el.style.opacity = '1';
        el.style.transform = 'none';
      });
    }
    addEventListener('load', function () {
      if (window.ScrollTrigger) window.ScrollTrigger.refresh();
      setTimeout(sweep, 900);
    });
    setTimeout(sweep, 3500);

    /* lerped smooth scroll, pointer devices only */
    if (fine) {
      var target = scrollY, current = scrollY, running = false;
      var maxY = function () { return document.documentElement.scrollHeight - innerHeight; };
      addEventListener('wheel', function (e) {
        if (e.ctrlKey) return;
        if (document.querySelector('.drawer.active, details[open] .menu-drawer')) return;
        e.preventDefault();
        target = Math.max(0, Math.min(maxY(), target + e.deltaY));
        running = true;
      }, { passive: false });
      addEventListener('scroll', function () { if (!running) target = current = scrollY; }, { passive: true });
      G.ticker.add(function () {
        if (!running) return;
        current += (target - current) * .115;
        if (Math.abs(target - current) < .4) { current = target; running = false; }
        scrollTo(0, current);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else { boot(); }
})();
